import { MenuIdHome } from '@jira/navigation-apps__constants/src/MenuIdHome.tsx';
import {
	LazyHorizontalOperationsOverviewNav,
	AsyncHorizontalOperationsOverviewNav,
} from '@jira/navigation-apps__horizontal-nav-jsm-operations-container/src/async.tsx';
import { getTeamsResource } from '@jira/router-resources__eoc-overview/src/getTeamsResource.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { firstProjectResource } from '@jira/router-resources__service-desk-project-getting-started/src/firstProjectResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocOverviewRoute } from '@jira/router-routes__eoc-overview-routes/src/eocOverviewRoute.tsx';
import { opsMigrationHubLayout } from '@jira/platform__layouts-ops-settings-layout/src/index.tsx';
import { eocCommonResources } from '@atlassian/eoc-resources/resources';
import { getGettingStartedPanelResource } from '@atlassian/eoc-overview/resources';
import { UNSAFE_noExposureExp } from '@atlassian/jira-feature-experiments';
import type { Route, RouteResources } from '@atlassian/react-resource-router';
import { EocOverviewComponent, LazyOverviewPage } from './ui/index.tsx';

// firstProjectResource is only consumed by the cross-flow onboarding (XFlowOnboarding + demoSpace),
// which is gated by lumos_ops_template_xflow. Skip the getFirstProject prefetch for non-enrolled
// users. Read WITHOUT exposure (exposure is fired upstream at template selection). Exposed as a
// function spread so the route entry stays a statically-analysable `() => ({})`.
const getXflowOnboardingResources = (): (typeof firstProjectResource)[] => {
	const [opsXflowExperiment] = UNSAFE_noExposureExp('lumos_ops_template_xflow');
	return opsXflowExperiment.get('isEnabled', false) ? [firstProjectResource] : [];
};

export const eocOverviewRouteEntry: Route = createEntry(eocOverviewRoute, () => ({
	group: 'eoc',
	// eslint-disable-next-line no-restricted-syntax
	component: EocOverviewComponent,
	layout: opsMigrationHubLayout,
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	resources: [
		...getNavigationResources(),
		getConsolidationStateResource(),
		getTeamsResource,
		getGettingStartedPanelResource,
		...getXflowOnboardingResources(),
		...eocCommonResources(),
	] as RouteResources,
	navigation: {
		menuId: MenuIdHome,
		horizontal: AsyncHorizontalOperationsOverviewNav,
	},
	forPaint: [LazyAtlassianNavigation, LazyHorizontalOperationsOverviewNav, LazyOverviewPage],
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
